var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.how-to",modifiers:{"how-to":true}}],staticClass:"w-50 m-4",attrs:{"size":"lg","variant":"info"}},[_vm._v(_vm._s(_vm.block.label))]),_c('b-modal',{attrs:{"id":"how-to","title":_vm.block.title,"ok-only":""}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.block.text)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }